<template>
  <b-card class="shadow-lg mb-4 sticky-top" style="top: 10px; z-index: 100;">
    <b-row align-v="center">
      <b-col cols="12" md="3">
        <div class="d-flex align-items-center">
          <div class="status-indicator mr-3">
            <div 
              :class="['status-dot', socketConnected ? 'status-dot-success' : 'status-dot-danger']"
            ></div>
          </div>
        </div>
      </b-col>
      
      <b-col cols="12" md="9" class="text-md-right mt-3 mt-md-0">
        <b-button-group size="sm" class="mr-2 mb-2 mb-md-0">
          <b-button variant="outline-primary" @click="$emit('refresh')">
            <i class="fas fa-sync-alt"></i>
            <span class="d-none d-lg-inline ml-1">Refresh</span>
          </b-button>
        </b-button-group>
        
        <b-button 
          variant="warning" 
          size="sm" 
          @click="$emit('assign')"
          class="mr-2 mb-2 mb-md-0"
        >
          <i class="fas fa-user-nurse"></i>
          <span class="d-none d-sm-inline ml-1">Assign Devices</span>
        </b-button>
        
        <b-button 
          variant="primary" 
          size="sm" 
          @click="$emit('config')"
          class="mb-2 mb-md-0"
        >
          <i class="fas fa-cog"></i>
          <span class="d-none d-sm-inline ml-1">Manage Beacons</span>
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'StatusCard',
  props: {
    socketConnected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['refresh', 'assign', 'config']
}
</script>

<style scoped>
.status-indicator {
  position: relative;
  width: 40px;
  height: 40px;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: relative;
}

.status-dot::before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: pulse-ring 2s ease-out infinite;
}

.status-dot-success {
  background: #2dce89;
}

.status-dot-success::before {
  border: 2px solid #2dce89;
}

.status-dot-danger {
  background: #f5365c;
}

.status-dot-danger::before {
  border: 2px solid #f5365c;
}

@keyframes pulse-ring {
  0% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(0.8);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.5);
  }
}

.btn-group {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
</style>